module.exports = __webpack_public_path__ + "img/1080_18.50319dc1.jpg";